import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

// TODO: Remove the whole thing concerning hotwire, stimulus, and importmaps.
// Also remove these npm dependencies:
// - @hotwired/stimulus
// - @hotwired/turbo-rails
// - stimulus-vite-helpers

// Import and register all controllers
const application = Application.start()
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
registerControllers(application, controllers)
